import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-metrics-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="metrics-badge" [class.widget-style]="style === 'widget'">
      @if (electric > 0) {
        <div class="metric electric" title="Total Electricity Usage">
          <div class="metric-icon">
            <i class="material-symbols-rounded">lightbulb</i>
          </div>
          <span>{{ electric | number }} kWh</span>
        </div>
      }
      @if (gas > 0) {
        <div class="metric gas" title="Total Gas Usage">
          <div class="metric-icon">
            <i class="material-symbols-rounded">local_fire_department</i>
          </div>
          <span>{{ gas | number }} DTH</span>
        </div>
      }
    </div>
    `,
  styleUrl: './metrics-badge.component.scss'
})
export class MetricsBadgeComponent {
    @Input() electric = 0;
    @Input() gas = 0;
    @Input() style: 'default' | 'widget' = 'default';
}
